module.exports = __webpack_public_path__ + "static/media/rectangular3.09807766.png";